import { React, useContext, useState } from "react";

import ThemeContext from "../../lib/theme-context";
import AuthContext from "../../lib/auth-context";

import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const UnarchivedTestsDropDown = ({
  selectedTest,
  onTestSelect,
  showBacktestTrades,
  label = "Select Test",
  includeMissedTrades = true,
  variant = "default",
  fullWidth = false,
}) => {
  const theme = useContext(ThemeContext);
  const auth = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const isCompact = variant === "compact";

  const handleChange = (event) => {
    const { value } = event.target;
    
    if (value === "Missed Trades") {
      showBacktestTrades({
        startDate: JSON.parse(localStorage.getItem("user")).created,
        archived: "false",
        notes: "",
        pair: "All missed trades from",
        testId: "Missed Trades",
      });
    } else {
      const selectedBacktest = auth.backtests?.find((test) => test.testId === value);
      if (selectedBacktest) {
        showBacktestTrades(selectedBacktest);
      }
    }
    
    onTestSelect(value);
  };

  return (
    <FormControl sx={fullWidth ? { width: "100%" } : (isCompact ? { width: 240 } : { width: 260, height: "50px" })} size="small">
      <Select
        autoWidth={false}
        MenuProps={{
          sx: {
            zIndex: 99999,
          },
          PaperProps: {
            sx: isCompact ? {
              maxHeight: 300,
              width: "240px",
              backgroundColor: theme[0] === "dark" ? "rgba(40, 42, 46)" : "#fff",
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
              "& .MuiMenuItem-root": {
                whiteSpace: "nowrap !important",
                overflow: "hidden !important",
                textOverflow: "ellipsis !important",
                display: "block !important",
                textAlign: "center !important",
              },
            } : fullWidth ? {
              bgcolor: theme[0] === "dark" ? "rgba(40, 42, 46)" : "#FCFCFF",
              maxHeight: "450px",
              minWidth: "200px",
              maxWidth: "400px",
              "& .MuiMenuItem-root": {
                padding: 1.5,
                justifyContent: "center",
                whiteSpace: "nowrap !important",
                overflow: "hidden !important",
                textOverflow: "ellipsis !important",
                display: "block !important",
                textAlign: "center !important",
              },
            } : {
              bgcolor: theme[0] === "dark" ? "rgba(40, 42, 46)" : "#FCFCFF",
              maxHeight: "450px",
              minWidth: "260px !important",
              maxWidth: "260px !important",
              "& .MuiMenuItem-root": {
                padding: 1.5,
                justifyContent: "center",
                whiteSpace: "nowrap !important",
                overflow: "hidden !important",
                textOverflow: "ellipsis !important",
                display: "block !important",
                textAlign: "center !important",
              },
            },
          },
        }}
        defaultValue=""
        fullWidth
        open={menuOpen}
        onOpen={() => setMenuOpen(true)}
        onClose={() => {
          setTimeout(() => setMenuOpen(false), 200);
        }}
        sx={isCompact ? {
          backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          color: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          borderRadius: menuOpen ? "12px 12px 0 0" : "12px",
          fontSize: "13px",
          fontWeight: 600,
          transition: "border-radius 0.2s ease-in-out",
          ".MuiSvgIcon-root": {
            fill: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          },
          "& fieldset": {
            border: "none",
          },
          "&:hover": {
            backgroundColor: theme[0] === "dark" ? "#434650" : "#d1d5db",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused": {
            backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
          "& .MuiSelect-select": {
            paddingTop: "6px",
            paddingBottom: "6px",
            paddingLeft: "10px",
            paddingRight: "10px",
          },
        } : {
          backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          color: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          borderRadius: menuOpen ? "12px 12px 0 0" : "12px",
          fontSize: "16px",
          fontWeight: 600,
          transition: "border-radius 0.2s ease-in-out",
          ".MuiSvgIcon-root": {
            fill: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          },
          "& fieldset": {
            border: "none",
          },
          "&:hover": {
            backgroundColor: theme[0] === "dark" ? "#434650" : "#d1d5db",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused": {
            backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
          "& .MuiSelect-select": {
            paddingTop: "8px",
            paddingBottom: "8px",
            paddingLeft: "12px",
            paddingRight: "12px",
          },
        }}
        value={selectedTest || ""}
        onChange={handleChange}
        displayEmpty
        renderValue={(selected) => {
          if (!selected || selected === "") {
            return (
              <span style={{ 
                color: theme[0] === "dark" ? "#9ca3af" : "#6b7280",
                fontWeight: 600
              }}>
                {label}
              </span>
            );
          }
          if (selected === "Missed Trades") {
            return (
              <span style={{ fontSize: isCompact ? "13px" : "14px" }}>
                Missed Trades
              </span>
            );
          }
          const selectedBacktest = auth.backtests?.find((test) => test.testId === selected);
          const displayText = selectedBacktest ? selectedBacktest.testId : label;
          return (
            <span style={{ fontSize: isCompact ? "13px" : "14px" }}>
              {displayText}
            </span>
          );
        }}
      >
        {includeMissedTrades && (
          <MenuItem
            sx={{
              color: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
            }}
            value="Missed Trades"
          >
            Missed Trades
          </MenuItem>
        )}
        {auth.backtests
          ?.filter((tests) => tests.archived?.includes("false"))
          .map((test) => (
            <MenuItem
              key={test.testId}
              sx={{
                color: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
              }}
              value={test.testId}
            >
              {test.testId}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default UnarchivedTestsDropDown;
